import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BamFavoriteBatchLog } from 'src/app/models/bam-log';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';

@Component({
  selector: 'app-bam-favorites-history',
  templateUrl: './bam-favorites-history.component.html',
  styleUrls: ['./bam-favorites-history.component.scss']
})
export class BamFavoritesHistoryComponent implements OnInit {

  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');
  pagination = {
    total: [] as BamFavoriteBatchLog[], // todos los registros traídos
    filter: [] as BamFavoriteBatchLog[], // registros visibles en la página actual
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  accountFilter: string = "";
  loading = false;

  constructor(private bamTransferServiceService: BamTransferServiceService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getTransfers();
  }

  getTransfers() {
    this.loading = true;
    this.bamTransferServiceService.getFavoriteHistory(this.startDate, this.endDate).subscribe({
      next: (res: ResponseObject) => {
        this.pagination.total = res.data;
        this.updateFilter();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastrService.error("Error", "No se puedo obtener el historial de transferencias");
      }
    });
  }

  updateFilter() {
    let data = [...this.pagination.total]; // o la lista completa de transfers cargados

    // Filtro por número de cuenta
    if (this.accountFilter && this.accountFilter.trim() !== "") {
      const accountSearch = this.accountFilter.trim().toLowerCase();
      data = data.filter(t =>
        (t.productNumber+'').toLowerCase().includes(accountSearch) ||
        t.batchId.toLowerCase().includes(accountSearch)
      );
    }

    this.pagination.total = data;
    this.resetPagination();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  changePage(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    const start = pageIndex * this.pagination.pageSize;
    const end = start + this.pagination.pageSize;
    this.pagination.filter = this.pagination.total.slice(start, end);
    this.pagination.startElement = start;
    this.pagination.lastElement = this.pagination.filter.length;
  }

  convertToString(dateStr: string | undefined): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('es-GT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatCreatedAt(createdAt: any): string {
    if (!createdAt) return '-';

    const day = createdAt.dayOfMonth.toString().padStart(2, '0');
    const month = createdAt.monthValue.toString().padStart(2, '0');
    const year = createdAt.year;

    const hour = createdAt.hour.toString().padStart(2, '0');
    const minute = createdAt.minute.toString().padStart(2, '0');
    const second = createdAt.second.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  }
}

